/**
 * Builder “through M{n}” target: repeat-to-M shortcut, save-time repeat through
 * M{n}, and repeat-final block when saving product configs.
 */
export const CURVE_MANAGEMENT_MAX_PERIODS = 47;

/**
 * Hard cap on total relative months (“cells”) summed across all segments:
 * add-segment buttons, duplicate, per-segment repetition clamps, config load.
 */
export const CURVE_MANAGEMENT_MAX_CELLS = 132;

/** Curve Management responsive breakpoints (px). See Figma Breakpoints (WEB-1748). */
export const CURVE_MGMT_BREAKPOINT_SMALL_MAX = 599; // 37.5rem @ 16px — Mobile
export const CURVE_MGMT_BREAKPOINT_MEDIUM_MAX = 1000; // 62.5rem — Tablet
export const CURVE_MGMT_BREAKPOINT_LARGE_MIN = CURVE_MGMT_BREAKPOINT_MEDIUM_MAX + 1; // 1001 — Laptop / Large
export const CURVE_MGMT_BREAKPOINT_DESKTOP_MIN = 1432; // 89.5rem — Desktop / ExtraLarge

/** Media query strings for use with `useMediaQuery`. */
export const CURVE_MGMT_MEDIA = {
  /** Tab layout: Mobile + Tablet (≤1000px). */
  narrow: `(max-width: ${CURVE_MGMT_BREAKPOINT_MEDIUM_MAX}px)`,
  /** Mobile only (≤599px). */
  mobile: `(max-width: ${CURVE_MGMT_BREAKPOINT_SMALL_MAX}px)`,
  /** Side-by-side layout: Large + Desktop (≥1001px). */
  sideBySide: `(min-width: ${CURVE_MGMT_BREAKPOINT_LARGE_MIN}px)`,
  /** Two-column metadata drawer: Desktop / ExtraLarge (≥1432px). */
  desktopXL: `(min-width: ${CURVE_MGMT_BREAKPOINT_DESKTOP_MIN}px)`,
} as const;
